<template>
  <div class="d-flex justify-content-center align-items-center gap-4">
    <shield-check-icon size="24" color="#94A3B8" />

    <p class="small-regular gray-400">
      Ambiente seguro
    </p>
  </div>
</template>

<script>
import { ShieldCheckIcon } from '@vue-hero-icons/outline';

export default {
  name: 'SecurityWarning',
  components: {
    ShieldCheckIcon,
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../scss/__new-styles.scss';

</style>
